<a class='menu-item' [routerLink]='["/about", "kolsherut"]'>אודות</a>
<a class='menu-item' [routerLink]='["/about", "missing"]'>הוסיפו שירות חסר</a>
<a class='menu-item' [routerLink]='["/about", "partners"]'>שותפים</a>
<a class='menu-item' href='https://www.kolzchut.org.il/he/%D7%9B%D7%9C_%D7%A9%D7%99%D7%A8%D7%95%D7%AA:%D7%A0%D7%92%D7%99%D7%A9%D7%95%D7%AA' target="_blank"
    aria-label='הצהרת נגישות - נפתח בחלון חדש' *ngIf='footer'>
    הצהרת נגישות
</a>
<a class='menu-item' [routerLink]='["/about", "contact"]'>צרו קשר</a>
<a class='menu-item' *ngIf='footer' [routerLink]='["/about", "index"]'>מפת אתר</a>
